import(/* webpackMode: "eager" */ "/vercel/path0/src/app/industry-categories/page.tsx");
